import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export const NavbarLog = () => {
    return (
        <nav className="navbar navbar-color py-3">
            <div className="container-fluid d-flex flex-column flex-sm-row align-items-center justify-content-between text-center">

                {/* Logo: centrado solo en móvil */}
                <Link to="/" className="mb-2 mb-sm-0">
                    <img
                        src="./assets/img/logoEncabezado.png"
                        alt="Logo"
                        className="navbar-img mx-auto mx-sm-0"
                        style={{ maxHeight: '60px', width: 'auto' }}
                    />
                </Link>

                {/* Botones: centrados y en fila en móvil, alineados a la derecha en pantallas grandes */}
                <div className="d-flex justify-content-center justify-content-sm-end gap-2 flex-wrap">
                    <Link to="/">
                        <button type="button" className="btn btn-outline-light">
                            <i className="fas fa-graduation-cap"></i> Carreras
                        </button>
                    </Link>
                    <Link to="/login">
                        <button type="button" className="btn btn-outline-light">
                            <i className="fas fa-user-circle"></i> Iniciar Sesión
                        </button>
                    </Link>
                </div>

            </div>
        </nav>

    )
}
